import HttpClient from '../../../services/http-client';
import { IUploadedDocumentResponse } from '../../../../model/apm/document/response/uploaded-document-response';

const defaultPath = 'Document';

// O Content-Type multipart (com boundary) é definido pelo axios a partir do FormData
const upload = async (file: File, onProgress?: (percent: number) => void): Promise<IUploadedDocumentResponse> => {
    const formData = new FormData();
    formData.append('File', file);

    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: formData,
        onUploadProgress: (event) => {
            if (onProgress && event.total) {
                onProgress(Math.round((event.loaded * 100) / event.total));
            }
        }
    }).then((response) => response.data);
};

const DocumentAppService = { upload };
export default DocumentAppService;
